<template>
  <a-layout id="components-layout-demo-top-side">
    <a-layout-header class="header">
      <Navbar />
    </a-layout-header>
    <a-layout-content style="padding: 0 50px">
      <a-layout style="padding: 24px 0; background: #fff">
        <a-layout-sider width="200" style="background: #fff">
          <Sidebar />
        </a-layout-sider>
        <a-layout-content :style="{ padding: '0 24px', minHeight: '780px' }">
         <router-view />
        </a-layout-content>
      </a-layout>
    </a-layout-content>
    <a-layout-footer style="text-align: center">
      <Footer />
    </a-layout-footer>
  </a-layout>
</template>
<script>
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import Footer from '../components/Footer';
export default {
  name:"DefaultLayout",
  components:{
    Navbar,
    Sidebar,
    Footer
  },
}
</script>


// WEBPACK FOOTER //
// src/views/Default.vue